document.addEventListener('DOMContentLoaded', () => {
    let lastProductId = null;

    const checkAndDispatchQuickview = () => {
        const quickview = document.querySelector('[data-view="quick-view"], .sf-pqv');
        if (!quickview) {
            lastProductId = null; 
            return;
        }

        const form = quickview.querySelector(
            '[bss-b2b-quickview-product-form]'
        );
        const productIdElem = quickview.querySelector('[bss-b2b-product-id]');
        const productId = productIdElem?.getAttribute('bss-b2b-product-id') 
            || productIdElem?.getAttribute('data-product-id') 
            || productIdElem?.value;

        if (form && productId && lastProductId !== productId) {
            lastProductId = productId;
            document.dispatchEvent(
                new Event('bss_b2b:QuickviewLoaded', { bubbles: true })
            );
        }
    };

    const observer = new MutationObserver(() => {
        checkAndDispatchQuickview();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
    });
});

document.addEventListener("click", e => {
  const path = e.composedPath();
  const selectorCheckout = `button[name="checkout"]`;
  const target = path.find(el => {
    return el?.matches?.(selectorCheckout);
  });
  if ((e.target && e.target.closest(selectorCheckout)) || target) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
  }
}, 1);